<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
<!--	key is tight to message to ensure loading indicator updates itself as needed. Otherwise when the message variable is changed, this doesn't always update the loading message on the UI-->
	<div class="loading-indicator-root"
		 :class="[isFullscreen? 'center-fixed' : 'center-absolute']"
		 :key="'key_' + messageText"
		 v-if="isShowing"
		v-loading="isShowing"
		:element-loading-text="messageText">
	</div>
</template>

<script>
    export default {
        name: "LoadingIndicator",
		props:{
			text: String,
			message: String,
			isLoading: Boolean,
			isFullscreen: Boolean,
		},

		data() {
			return {
				isDataLoadingInternal: true
			}
		},

		computed:{
			messageText(){
				return this.message || this.text || this.$parent.progressText || "Loading..."
			},

			isShowing(){
				console.log("LoadingIndicator.isShowing: ", this.$parent.isDataLoading, ", this.$parent = ", this.$parent, ", this = ", this)
				return this.isLoading || this.$parent.isDataLoading
			}
		}
    }
</script>

<style lang="scss">
.loading-indicator-root{

	min-height: 5rem;//80px;

	.el-loading-spinner{
		transform: translateY(-50%);
		margin-top: 0;
	}
}

</style>
